"use strict";

/**
 * Created by Kirill Mashchenko on 17.05.23.
 */

/**
 * @class 2D Level where robot is a copy pf physical press robot and can connect to real physical press robot.
 * @implements pm.AbstractLevel
 */
pm.data.PressRobotLevel = pm.AbstractLevel.extend(/** @lends pm.data.PressRobotLevel# */{
	typeName: "PressRobotLevel",
	/**
	 * Robots can be indicated.
	 * @type {Boolean}
	 */
	robotsCanBeIndicated: false,

	ctor: function()
	{
		this._super();
	},

	load: function(preview, robotIndex)
	{
		pm.AbstractLevel.prototype.load.call(this, preview, robotIndex);
	},

	hasPhysicalConnector: function() { return true; },

	_supportsPhysicalConnector: function(type)
	{
		return type !== pm.PhysicalConnectorType.Magnet;
	},

	_physicalStateChanged: function(state)
	{
		for(var i = 0; i < this.robots.length; ++i)
			this.robots[i].pressStateChanged(state);
	},

	getType: function() { return pm.PressRobotLevelModule.Type; }
});
